import { c as _c } from "react/compiler-runtime";
// Вкладка «О магазине» на карточке товара (кадр 4052:40245, Айталы 02.10, A-14).
//
// Сверху — фото магазина 47×47 r16 и название 16/20 w600: оба ссылки на страницу
// магазина; под названием рейтинг ★ 14/19. Справа — серая «Написать продавцу»
// (32, r8, 12/16 w600). Ниже две строки-ссылки 14/18 со счётчиком товаров и
// шевроном: «Все <категория> <магазин>» и «Все товары <магазин>».
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { api } from "@/api";
import { ChevronRight20Icon, StarIcon } from "@/components/icons";
import { VerifiedSellerBadge } from "@/components/shop/verified-badge";
import { Button } from "@/components/ui/button";
export type ProductShopTabShop = {
  id: string;
  slug?: string;
  name: string;
  rating: number;
  logoUrl?: string;
  /** «Проверенный продавец» (П7, fd-onboard-12). */
  verified?: boolean;
};
export function ProductShopTab(t0) {
  const $ = _c(70);
  const {
    shop,
    category,
    onMessage
  } = t0;
  const {
    t
  } = useTranslation();
  const shopHref = shop.slug ? `/shop/${encodeURIComponent(shop.slug)}` : undefined;
  let t1;
  if ($[0] !== shop.id) {
    t1 = {
      queryKey: ["products", "list", shop.id, "count"],
      queryFn: () => api.products.list({
        shopId: shop.id,
        pageSize: 1
      }),
      staleTime: 300000
    };
    $[0] = shop.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const all = useQuery(t1);
  const t2 = category?.id ?? "none";
  let t3;
  if ($[2] !== shop.id || $[3] !== t2) {
    t3 = ["products", "list", shop.id, "count", t2];
    $[2] = shop.id;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== category?.id || $[6] !== shop.id) {
    t4 = () => api.products.list({
      shopId: shop.id,
      categoryId: category?.id,
      pageSize: 1
    });
    $[5] = category?.id;
    $[6] = shop.id;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = Boolean(category?.id);
  let t6;
  if ($[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
    t6 = {
      queryKey: t3,
      queryFn: t4,
      enabled: t5,
      staleTime: 300000
    };
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const inCategory = useQuery(t6);
  const categoryCount = inCategory.data?.meta.total ?? 0;
  const allCount = all.data?.meta.total ?? 0;
  let t7;
  if ($[12] !== shop.logoUrl) {
    t7 = shop.logoUrl ? <img src={shop.logoUrl} alt="" className="size-full object-cover" /> : null;
    $[12] = shop.logoUrl;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t7) {
    t8 = <span className="flex size-[47px] shrink-0 items-center justify-center overflow-hidden rounded-[16px] bg-[#E2E2E2]">{t7}</span>;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const avatar = t8;
  let t10;
  let t11;
  let t12;
  let t13;
  let t9;
  if ($[16] !== allCount || $[17] !== avatar || $[18] !== category || $[19] !== categoryCount || $[20] !== onMessage || $[21] !== shop.name || $[22] !== shop.rating || $[23] !== shop.verified || $[24] !== shopHref || $[25] !== t) {
    const rows = [...(category && categoryCount > 0 ? [{
      key: "category",
      title: /[иы]$/i.test(category.name.trim().split(/\s+/)[0] ?? "") ? t("product.shopAllInCategory", {
        category: category.name.toLocaleLowerCase("ru-RU"),
        shop: shop.name
      }) : t("product.shopCategory", {
        category: category.name,
        shop: shop.name
      }),
      count: categoryCount,
      href: shopHref ? `${shopHref}?category=${encodeURIComponent(category.name)}` : undefined
    }] : []), {
      key: "all",
      title: t("product.shopAllProducts", {
        shop: shop.name
      }),
      count: allCount,
      href: shopHref
    }];
    t11 = "flex flex-col gap-3";
    t12 = "product-shop-tab";
    let t14;
    if ($[31] !== avatar || $[32] !== shop.name || $[33] !== shopHref) {
      t14 = shopHref ? <Link to={shopHref} aria-label={shop.name} data-testid="product-shop-avatar" className="rounded-[16px] outline-none focus-visible:ring-2 focus-visible:ring-ds-focus">{avatar}</Link> : avatar;
      $[31] = avatar;
      $[32] = shop.name;
      $[33] = shopHref;
      $[34] = t14;
    } else {
      t14 = $[34];
    }
    let t15;
    if ($[35] !== shop.name || $[36] !== shopHref) {
      t15 = shopHref ? <Link to={shopHref} data-testid="product-shop-name" className="truncate text-[16px] font-semibold leading-5 tracking-[-0.31px] text-black outline-none transition-colors hover:text-osmix-tangelo focus-visible:text-osmix-tangelo">{shop.name}</Link> : <span className="truncate text-[16px] font-semibold leading-5 tracking-[-0.31px] text-black">{shop.name}</span>;
      $[35] = shop.name;
      $[36] = shopHref;
      $[37] = t15;
    } else {
      t15 = $[37];
    }
    let t16;
    if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
      t16 = <StarIcon className="text-[#161616]" />;
      $[38] = t16;
    } else {
      t16 = $[38];
    }
    let t17;
    if ($[39] !== shop.rating) {
      t17 = shop.rating.toFixed(1);
      $[39] = shop.rating;
      $[40] = t17;
    } else {
      t17 = $[40];
    }
    let t18;
    if ($[41] !== t17) {
      t18 = <span className="flex items-center gap-1">{t16}{t17}</span>;
      $[41] = t17;
      $[42] = t18;
    } else {
      t18 = $[42];
    }
    let t19;
    if ($[43] !== shop.verified) {
      t19 = shop.verified && <VerifiedSellerBadge />;
      $[43] = shop.verified;
      $[44] = t19;
    } else {
      t19 = $[44];
    }
    let t20;
    if ($[45] !== t18 || $[46] !== t19) {
      t20 = <span className="flex flex-wrap items-center gap-x-2 gap-y-1 text-[14px] font-medium leading-[19px] tracking-[-0.28px] text-[#161616]">{t18}{t19}</span>;
      $[45] = t18;
      $[46] = t19;
      $[47] = t20;
    } else {
      t20 = $[47];
    }
    let t21;
    if ($[48] !== t15 || $[49] !== t20) {
      t21 = <div className="flex min-w-0 flex-col gap-2">{t15}{t20}</div>;
      $[48] = t15;
      $[49] = t20;
      $[50] = t21;
    } else {
      t21 = $[50];
    }
    let t22;
    if ($[51] !== t14 || $[52] !== t21) {
      t22 = <div className="flex min-w-0 items-center gap-2.5">{t14}{t21}</div>;
      $[51] = t14;
      $[52] = t21;
      $[53] = t22;
    } else {
      t22 = $[53];
    }
    let t23;
    if ($[54] !== t) {
      t23 = t("product.messageSeller");
      $[54] = t;
      $[55] = t23;
    } else {
      t23 = $[55];
    }
    let t24;
    if ($[56] !== onMessage || $[57] !== t23) {
      t24 = <Button variant="gray" size="sm" onClick={onMessage}>{t23}</Button>;
      $[56] = onMessage;
      $[57] = t23;
      $[58] = t24;
    } else {
      t24 = $[58];
    }
    if ($[59] !== t22 || $[60] !== t24) {
      t13 = <div className="flex items-center justify-between gap-3">{t22}{t24}</div>;
      $[59] = t22;
      $[60] = t24;
      $[61] = t13;
    } else {
      t13 = $[61];
    }
    t9 = "flex flex-col";
    t10 = rows.map((row, index) => {
      const body = <><span className="flex min-w-0 flex-col gap-1.5"><span className="truncate text-[14px] font-semibold leading-[18px] text-black">{row.title}</span><span className="text-[14px] leading-[18px] text-[#161616]">{t("product.goodsCount", {
              count: row.count
            })}</span></span><ChevronRight20Icon className="shrink-0 text-[#1F1F1F]" /></>;
      return <li key={row.key} className={index > 0 ? "mt-2.5 border-t border-[#1F1F1F]/8 pt-2.5" : undefined}>{row.href ? <Link to={row.href} data-testid={`product-shop-${row.key}`} className="flex items-center justify-between gap-3 rounded-[4px] outline-none transition-colors hover:text-osmix-tangelo focus-visible:ring-2 focus-visible:ring-ds-focus">{body}</Link> : <div className="flex items-center justify-between gap-3">{body}</div>}</li>;
    });
    $[16] = allCount;
    $[17] = avatar;
    $[18] = category;
    $[19] = categoryCount;
    $[20] = onMessage;
    $[21] = shop.name;
    $[22] = shop.rating;
    $[23] = shop.verified;
    $[24] = shopHref;
    $[25] = t;
    $[26] = t10;
    $[27] = t11;
    $[28] = t12;
    $[29] = t13;
    $[30] = t9;
  } else {
    t10 = $[26];
    t11 = $[27];
    t12 = $[28];
    t13 = $[29];
    t9 = $[30];
  }
  let t14;
  if ($[62] !== t10 || $[63] !== t9) {
    t14 = <ul className={t9}>{t10}</ul>;
    $[62] = t10;
    $[63] = t9;
    $[64] = t14;
  } else {
    t14 = $[64];
  }
  let t15;
  if ($[65] !== t11 || $[66] !== t12 || $[67] !== t13 || $[68] !== t14) {
    t15 = <div className={t11} data-testid={t12}>{t13}{t14}</div>;
    $[65] = t11;
    $[66] = t12;
    $[67] = t13;
    $[68] = t14;
    $[69] = t15;
  } else {
    t15 = $[69];
  }
  return t15;
}